'use strict';

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));

var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));

var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));

var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));

var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));

var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));

var React = require('react');

var React__default = _interopDefault(React);

var reactMobiledocEditor = require('react-mobiledoc-editor');

var PropTypes = _interopDefault(require('prop-types'));

var _slugify = _interopDefault(require('slugify'));

var _assertThisInitialized = _interopDefault(require('@babel/runtime/helpers/assertThisInitialized'));

var includes = _interopDefault(require('lodash.includes'));

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));

var Renderer03 = _interopDefault(require('@dailybeast/mobiledoc-react-renderer/dist/renderers/0-3'));

var Renderer = _interopDefault(require('@dailybeast/mobiledoc-react-renderer'));

var styled = _interopDefault(require('styled-components'));

var recompose = require('recompose');

var classNames = _interopDefault(require('classnames'));

var Fade = _interopDefault(require('react-reveal/Fade'));

var crane = require('@wingscms/crane');

var qs = _interopDefault(require('qs'));

var reactSticky = require('react-sticky');

var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));

var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));

var _asyncToGenerator = _interopDefault(require('@babel/runtime/helpers/asyncToGenerator'));

var SchemaForm = _interopDefault(require('@wingscms/crane-jsonschema-form'));

var deepmerge = _interopDefault(require('deepmerge'));

var CountUp = _interopDefault(require('react-countup'));

var createCard = function createCard(_ref) {
  var ViewComp = _ref.renderWith,
      Editor = _ref.editWith,
      name = _ref.name,
      _ref$payload = _ref.payload,
      defaultPayload = _ref$payload === void 0 ? {} : _ref$payload,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText;

  var MobiledocCard = /*#__PURE__*/function (_Component) {
    _inherits(MobiledocCard, _Component);

    function MobiledocCard() {
      _classCallCheck(this, MobiledocCard);

      return _possibleConstructorReturn(this, _getPrototypeOf(MobiledocCard).apply(this, arguments));
    }

    _createClass(MobiledocCard, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            isInEditor = _this$props.isInEditor,
            isEditing = _this$props.isEditing,
            edit = _this$props.edit,
            payload = _this$props.payload;
        if (!isInEditor) return React__default.createElement(ViewComp, payload);
        return !isEditing ? React__default.createElement(ViewComp, _extends({}, payload, {
          onClick: edit
        })) : React__default.createElement(Editor, this.props);
      }
    }]);

    return MobiledocCard;
  }(React.Component);

  _defineProperty(MobiledocCard, "displayName", name);

  _defineProperty(MobiledocCard, "propTypes", {
    isInEditor: PropTypes.bool.isRequired,
    isEditing: PropTypes.bool.isRequired,
    edit: PropTypes.func,
    payload: PropTypes.object
  });

  _defineProperty(MobiledocCard, "defaultProps", {
    payload: {},
    edit: function edit() {}
  });

  var Button = /*#__PURE__*/function (_Component2) {
    _inherits(Button, _Component2);

    function Button() {
      _classCallCheck(this, Button);

      return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
    }

    _createClass(Button, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            edit = _this$props2.edit,
            props = _objectWithoutProperties(_this$props2, ["edit"]);

        var editor = this.context.editor;
        return React__default.createElement("button", _extends({}, props, {
          onClick: function onClick() {
            return editor.insertCard(name, defaultPayload, edit);
          }
        }), buttonText || name);
      }
    }]);

    return Button;
  }(React.Component);

  _defineProperty(Button, "displayName", "".concat(name, "Button"));

  _defineProperty(Button, "propTypes", {
    edit: PropTypes.bool
  });

  _defineProperty(Button, "defaultProps", {
    edit: false
  });

  _defineProperty(Button, "contextTypes", {
    editor: PropTypes.object
  });

  var Card = reactMobiledocEditor.classToDOMCard(MobiledocCard);
  Card.Button = Button;
  Card.View = ViewComp;
  return Card;
};

var slugify = function slugify(s) {
  return _slugify(s, {
    remove: /[$*_+~.()'"!\-:@]/g,
    lower: true
  });
};

var enumerate = function enumerate() {
  var obj = {};

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (arg, i) {
    obj[obj[arg] = i] = arg;
  });
  return obj;
};

var WingsContext = React.createContext(null);

var Wings = function Wings(_ref) {
  var client = _ref.client,
      children = _ref.children;
  return React__default.createElement(WingsContext.Provider, {
    value: client
  }, children);
};

var useWings = function useWings() {
  return React.useContext(WingsContext);
};

var withWings = function withWings(Comp) {
  return function (props) {
    return React__default.createElement(WingsContext.Consumer, null, function (client) {
      return React__default.createElement(Comp, _extends({}, props, {
        wings: client
      }));
    });
  };
};

var _require = require('styled-components'),
    css = _require.css,
    withTheme = _require.withTheme,
    ThemeContext = _require.ThemeContext;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  @media screen and (min-width: 600px) {\n    font-size: 18px;\n  }\n  @media screen and (min-width: 800px) {\n    font-size: 23px;\n  }\n  p a,\n  ol a,\n  ul a {\n    color: ", ";\n    text-decoration: none;\n    background-image: linear-gradient(\n      120deg,\n      ", " 0%,\n      ", " 100%\n    );\n    background-repeat: no-repeat;\n    background-size: 100% 2px;\n    background-position: 0% 100%;\n    transition: background-size 0.1s linear;\n    &:hover,\n    &:focus {\n      background-size: 100% 4px;\n      background-image: linear-gradient(\n        120deg,\n        ", " 0%,\n        ", " 100%\n      );\n    }\n  }\n  color: ", ";\n  padding-bottom: ", ";\n  font-weight: ", ";\n  > * {\n    margin-bottom: 0;\n    margin-top: 0;\n    & + * {\n      margin-top: 1rem;\n      @media screen and (min-width: 800px) {\n        margin-top: 1.5rem;\n      }\n    }\n    & + h2,\n    & + h3 {\n      margin-top: 1.5rem;\n      @media screen and (min-width: 800px) {\n        margin-top: 3rem;\n      }\n    }\n  }\n  & > div > p:first-child {\n    margin-top: ", ";\n    @media screen and (max-width: 800px) {\n      margin-top: ", ";\n    }\n  }\n  &.drop-cap > div > p:first-child {\n    &::first-letter {\n      font-weight: ", "!important;\n      color: ", ";\n      float: left;\n      line-height: ", ";\n      margin: 0.075em 0.1em -0.1em 0;\n      font-size: ", ";\n      font-family: ", ";\n    }\n  }\n  > div {\n    > ul,\n    > ol {\n      li {\n        margin: 0;\n      }\n    }\n    > blockquote {\n      border-left: 2px solid ", ";\n      margin: 0;\n      padding: 0 0 0 1rem;\n      color: #000;\n    }\n    > h2,\n    > h3,\n    > h4,\n    > h5,\n    > h6 {\n      color: ", ";\n      margin-bottom: ", ";\n      line-height: 1.2;\n      text-transform: ", ";\n      @media screen and (min-width: 800px) {\n        margin-bottom: ", ";\n      }\n    }\n  }\n  &.drop-cap > div > div.headerContainer + p {\n    position: relative;\n    &::first-letter {\n      font-weight: ", "!important;\n      color: ", ";\n      float: left;\n      line-height: ", ";\n      margin: 0.075em 0.1em -0.2em 0;\n      font-size: ", ";\n      font-family: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

Renderer03.prototype.parseProps = function parseProps(attrss) {
  if (attrss) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, attrss[0], attrss[1]), _defineProperty(_ref, attrss[2], attrss[3]), _ref;
  }

  return null;
};

var MobiledocRenderer = /*#__PURE__*/function (_Component) {
  _inherits(MobiledocRenderer, _Component);

  function MobiledocRenderer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MobiledocRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MobiledocRenderer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "injectCardProps", function (card) {
      var cardPropsProp = _this.props.cardProps;
      var cardRender = card.render;
      return _objectSpread({}, card, {
        render: function render(_ref2) {
          var payload = _ref2.payload;
          return cardRender(_objectSpread({
            payload: payload,
            sectionKey: payload.key
          }, cardPropsProp[card.name]));
        }
      });
    });

    return _this;
  }

  _createClass(MobiledocRenderer, [{
    key: "createRenderer",
    value: function createRenderer() {
      var _this$props = this.props,
          cards = _this$props.cards,
          unknownCardHandler = _this$props.unknownCardHandler;
      return new Renderer({
        cards: cards.map(this.injectCardProps),
        unknownCardHandler: unknownCardHandler
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          content = _this$props2.content,
          _cards = _this$props2.cards,
          unknownCardHandler = _this$props2.unknownCardHandler,
          _ = _this$props2.cardProps,
          props = _objectWithoutProperties(_this$props2, ["content", "cards", "unknownCardHandler", "cardProps"]);

      var renderer = this.createRenderer();
      return React__default.createElement("div", props, !content ? null : renderer.render(JSON.parse(content)));
    }
  }]);

  return MobiledocRenderer;
}(React.Component);

_defineProperty(MobiledocRenderer, "propTypes", {
  content: PropTypes.string,
  cards: PropTypes.array,
  unknownCardHandler: PropTypes.func
});

_defineProperty(MobiledocRenderer, "defaultProps", {
  content: null,
  cards: [],
  unknownCardHandler: function unknownCardHandler(_ref28) {
    var name = _ref28.env.name;
    return console.error("Unknown card type ".concat(name, " encountered."));
  }
});

var MobiledocRenderer$1 = styled(MobiledocRenderer)(_templateObject(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.textColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primaryColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.primaryColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.textColor;
}, function (_ref9) {
  var mini = _ref9.mini;
  return mini ? '0' : '40px';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.bodyFontWeight;
}, function (_ref11) {
  var mini = _ref11.mini,
      theme = _ref11.theme;
  return mini ? '0' : theme.largeSpacing;
}, function (_ref12) {
  var mini = _ref12.mini,
      theme = _ref12.theme;
  return mini ? '0' : theme.mediumSpacing;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.firstLetterFontWeight;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.primaryColor;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.firstLetterLineHeight;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.dropcapFontSize;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.headingFont;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.primaryColor;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.textColor;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.extraSmallSpacing;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.smallSpacing;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.firstLetterFontWeight;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.primaryColor;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.firstLetterLineHeight;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.dropcapFontSize;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.headingFont;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " 0;\n  @media screen and (min-width: 800px) {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n  img {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n    width: 100%;\n  }\n  figcaption {\n    font-size: 0.7em;\n    line-height: 1.4;\n    padding: 10px;\n    color: #888;\n    text-align: center;\n    font-family: sans-serif;\n\n  }\n  &.size-", " {\n    max-width: 400px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  &.size-", " {\n    ", ";\n    img {\n      max-width: 1200px;\n      width: 100%;\n    }\n    figcaption {\n      max-width: 1200px;\n      width: 100%;\n      margin: 0 auto;\n      @media screen and (min-width: 1200px) {\n        padding: 10px 0;\n      }\n    }\n  }\n  &.size-", " {\n    ", ";\n    img {\n      max-width: 1600px;\n      width: 100%;\n    }\n    figcaption {\n      max-width: 1600px;\n      width: 100%;\n      margin: 0 auto;\n      @media screen and (min-width: 1600px) {\n        padding: 10px 0;\n      }\n    }\n  }\n  &.align-", " {\n    ", ";\n    @media screen and (min-width: 800px) {\n      figcaption {\n        padding: 10px 0;\n      }\n    }\n  }\n  &.align-", " {\n    ", ";\n    @media screen and (min-width: 800px) {\n      figcaption {\n        padding: 10px 0;\n      }\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var SIZE = enumerate('MEDIUM', 'LARGE', 'EXTRALARGE');
var FLOAT = enumerate('NONE', 'LEFT', 'RIGHT');
var propTypes = {
  mediaId: PropTypes.string.isRequired,
  url: PropTypes.string,
  src: PropTypes.string,
  large: PropTypes.string,
  alt: PropTypes.string,
  caption: PropTypes.string,
  size: PropTypes.number,
  "float": PropTypes.number
};
var defaultProps = {
  mediaId: '',
  url: '',
  large: '',
  src: '',
  alt: '',
  caption: '',
  size: SIZE.LARGE,
  "float": FLOAT.NONE
};
var Image = styled.figure(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.largeSpacing;
}, SIZE.MEDIUM, SIZE.LARGE, crane.wide, SIZE.EXTRALARGE, crane.wide, FLOAT.LEFT, crane.ALIGNLEFT, FLOAT.RIGHT, crane.ALIGNRIGHT);
/* eslint-disable jsx-a11y/alt-text */

var ImageCard = recompose.compose(recompose.setPropTypes(propTypes), recompose.setStatic('defaultProps', defaultProps))(function (_ref4) {
  var size = _ref4.size,
      _float = _ref4["float"],
      className = _ref4.className,
      mediaId = _ref4.mediaId,
      url = _ref4.url,
      caption = _ref4.caption,
      onClick = _ref4.onClick,
      _mediaId = _ref4._mediaId,
      props = _objectWithoutProperties(_ref4, ["size", "float", "className", "mediaId", "url", "caption", "onClick", "_mediaId"]);

  return React__default.createElement(Fade, {
    bottom: true,
    distance: "20px"
  }, React__default.createElement(Image, {
    onClick: onClick,
    className: classNames("size-".concat(size), className, _defineProperty({}, "align-".concat(_float), size === SIZE.MEDIUM))
  }, React__default.createElement("img", props), !caption ? null : React__default.createElement("figcaption", null, caption)));
});
/* eslint-enable jsx-a11y/alt-text */

var _ImageCard = createCard({
  name: 'ImageCard',
  renderWith: ImageCard
});

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 30px;\n  font-family: ", ";\n  line-height: 1.2;\n  color: ", ";\n  text-align: center;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  ", ";\n  width: 100vw;\n  @media screen and (min-width: 800px) {\n    font-size: 60px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n  .inner {\n    background: ", ";\n    margin: 0 auto;\n    max-width: 1160px;\n  }\n  strong {\n    display: block;\n    max-width: 760px;\n    height: 100%;\n    padding: ", " 10px;\n    margin: 0 auto;\n    @media screen and (min-width: 800px) {\n      padding: ", " 0;\n    }\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var Insight = styled.div(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.headerFontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return crane.getContrastColor({
    backgroundColor: theme.primaryColor || '#ffffff',
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediumSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediumSpacing;
}, crane.wide, function (_ref5) {
  var theme = _ref5.theme;
  return theme.largeSpacing;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.largeSpacing;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.primaryColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediumSpacing;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.largeSpacing;
});

var InsightCardView = /*#__PURE__*/function (_Component) {
  _inherits(InsightCardView, _Component);

  function InsightCardView() {
    _classCallCheck(this, InsightCardView);

    return _possibleConstructorReturn(this, _getPrototypeOf(InsightCardView).apply(this, arguments));
  }

  _createClass(InsightCardView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          props = _objectWithoutProperties(_this$props, ["text"]);

      return React__default.createElement(Insight, props, React__default.createElement("div", {
        className: "inner"
      }, React__default.createElement("strong", null, text)));
    }
  }]);

  return InsightCardView;
}(React.Component);

_defineProperty(InsightCardView, "defaultProps", {
  text: PropTypes.node
});

_defineProperty(InsightCardView, "defaultProps", {
  text: ''
});

var _InsightCard = createCard({
  name: 'InsightCard',
  renderWith: InsightCardView
});

var enumerate$1 = function enumerate() {
  var obj = {};

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (arg, i) {
    obj[obj[arg] = i] = arg;
  });
  return obj;
};

var TYPE = enumerate$1('BLOCKQUOTE', 'PULLQUOTE');
var FLOAT$1 = enumerate$1('NONE', 'LEFT', 'RIGHT');
var propTypes$1 = {
  text: PropTypes.node.isRequired,
  source: PropTypes.string,
  sourceUrl: PropTypes.string,
  type: PropTypes.number,
  "float": PropTypes.number
};
var defaultProps$1 = {
  source: '',
  sourceUrl: '',
  type: TYPE.BLOCKQUOTE,
  "float": FLOAT$1.NONE
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["data:image/svg+xml;utf8,<svg width=\"47px\" height=\"36px\" viewBox=\"0 0 47 36\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Text-elements/Quote/Blockquote\" transform=\"translate(-357.000000, 0.000000)\" fill=\"", "\"><path d=\"M369.787589,0 L376.966587,5.86833856 C373.377088,7.67398119 368.665871,12.5266458 367.544153,16.5893417 C367.99284,16.476489 369.002387,16.2507837 370.124105,16.2507837 C374.835322,16.2507837 378.761337,19.9749216 378.761337,25.5047022 C378.761337,31.2601881 374.050119,36 368.441527,36 C362.384248,36 357,31.1473354 357,22.9090909 C357,13.6551724 361.935561,5.64263323 369.787589,0 Z M395.026253,0 L402.205251,5.86833856 C398.615752,7.67398119 394.016706,12.5266458 392.782816,16.5893417 C393.231504,16.476489 394.24105,16.2507837 395.362768,16.2507837 C400.186158,16.2507837 404,19.9749216 404,25.5047022 C404,31.2601881 399.288783,36 393.792363,36 C387.735084,36 382.238663,31.1473354 382.238663,22.9090909 C382.238663,13.6551724 387.174224,5.64263323 395.026253,0 Z\" id=\"\u201C\"></path></g></g></svg>"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var quote = css(_templateObject$3(), function (_ref) {
  var theme = _ref.theme;
  return encodeURIComponent(theme.iconColor);
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  clear: both;\n  width: 100%;\n  text-align: center;\n  margin: ", " 0;\n  box-shadow: ", ";\n  padding: 30px;\n  background-color: ", ";\n  a { \n      color: #000000;\n      text-decoration: none;\n      background-image: linear-gradient(\n        120deg,\n        ", " 0%,\n        ", " 100%\n      );\n      background-repeat: no-repeat;\n      background-size: 100% 2px;\n      background-position: 0% 100%;\n      transition: background-size 0.1s linear;\n      &:hover,\n      &:focus {\n        background-size: 100% 4px;\n        background-image: linear-gradient(120deg, ", " 0%, ", " 100%);\n      }\n    }\n  @media screen and (max-width: 800px) {\n      margin-top: 40px;\n      margin-bottom: 40px;\n  }\n  &.pullquote-", ",\n  &.pullquote-", ",\n  &.pullquote-", " {\n    background-color: ", ";\n    margin: 40px 0;\n    padding: 20px;\n    box-shadow: none;\n    aside {\n      font-family: ", ";\n      font-size: 1.8em;\n      line-height: 1.2;\n    }\n    figcaption {\n      margin-top: 20px;\n      font-size: 0.8em;\n    }\n  }\n  &.pullquote-", " {\n    ", ";\n    aside {\n      max-width: 1200px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n  &.pullquote-", " {\n    ", ";\n  }\n  &.pullquote-", " {\n    ", ";\n  }\n  &.pullquote-", ",\n  &.pullquote-", " {\n    clear: none;\n    text-align: left;\n    @media screen and (max-width: 800px) {\n      width: 100%;\n      float: none;\n    }\n  }\n  aside {\n    color: ", ";\n    padding: 0;\n    font-weight: ", ";\n  }\n  blockquote {\n    color: ", ";\n    background-color: ", ";\n    padding: 0;\n    font-weight: ", ";\n    font-size: 0.9em;\n    font-style: italic;\n    text-align: left;\n    position: relative;\n    margin: 0;\n    &:after {\n      content: '';\n      position: absolute;\n      height: 50px;\n      width: 50px;\n      background-image: url('", "');\n      background-repeat: no-repeat;\n      left: 50%;\n      transform: translateX(-50%);\n      top: -50px;\n    }\n  }\n  figcaption {\n    margin-top: 1rem;\n    color: ", ";\n    &:before {\n      content: '\u2014 ';\n    }\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Quote = styled.figure(_templateObject$4(), function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.defaultShadow;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.blockquoteBackgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primaryColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.primaryColor;
}, FLOAT$1.NONE, FLOAT$1.LEFT, FLOAT$1.RIGHT, function (_ref8) {
  var theme = _ref8.theme;
  return theme.pullquoteBackgroundColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.headerFontFamily;
}, FLOAT$1.NONE, crane.wide, FLOAT$1.LEFT, crane.ALIGNLEFT, FLOAT$1.RIGHT, crane.ALIGNRIGHT, FLOAT$1.LEFT, FLOAT$1.RIGHT, function (_ref10) {
  var theme = _ref10.theme;
  return theme.pullquoteColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.pullquoteFontWeight;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.blockquoteColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.blockquoteBackgroundColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.blockquoteFontWeight;
}, quote, function (_ref15) {
  var theme = _ref15.theme;
  return theme.textColor;
});

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  margin-top: -30px;\n  margin-bottom: ", ";\n  color: ", ";\n  text-align: center;\n  font-size: 0.8em;\n  a { \n    color: #000000;\n    text-decoration: none;\n    background-image: linear-gradient(\n      120deg,\n      ", " 0%,\n      ", " 100%\n    );\n    background-repeat: no-repeat;\n    background-size: 100% 2px;\n    background-position: 0% 100%;\n    transition: background-size 0.1s linear;\n    &:hover,\n    &:focus {\n      background-size: 100% 4px;\n      background-image: linear-gradient(120deg, ", " 0%, ", " 100%);\n    }\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var Caption = styled.figcaption(_templateObject$5(), function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primaryColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primaryColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryColor;
});
var Blockquote = Quote;
var BlockquoteView = recompose.compose(recompose.setPropTypes(propTypes$1), recompose.setStatic('defaultProps', defaultProps$1))(function (_ref7) {
  var text = _ref7.text,
      source = _ref7.source,
      sourceUrl = _ref7.sourceUrl,
      props = _objectWithoutProperties(_ref7, ["text", "source", "sourceUrl"]);

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Blockquote, props, React__default.createElement("blockquote", null, text)), !source ? null : React__default.createElement(Caption, null, !sourceUrl ? source : React__default.createElement("a", {
    href: sourceUrl
  }, source)));
});
var PullquoteView = recompose.compose(recompose.setPropTypes(propTypes$1), recompose.setStatic('defaultProps', defaultProps$1))(function (_ref) {
  var text = _ref.text,
      source = _ref.source,
      sourceUrl = _ref.sourceUrl,
      _float = _ref["float"],
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["text", "source", "sourceUrl", "float", "className"]);

  return React__default.createElement(Quote, _extends({}, props, {
    className: classNames("pullquote-".concat(_float), className)
  }), React__default.createElement("aside", null, text), !source ? null : React__default.createElement("figcaption", null, !sourceUrl ? source : React__default.createElement("a", {
    href: sourceUrl
  }, source)));
});

var QuoteCardView = /*#__PURE__*/function (_Component) {
  _inherits(QuoteCardView, _Component);

  function QuoteCardView() {
    _classCallCheck(this, QuoteCardView);

    return _possibleConstructorReturn(this, _getPrototypeOf(QuoteCardView).apply(this, arguments));
  }

  _createClass(QuoteCardView, [{
    key: "getComponent",
    value: function getComponent() {
      switch (this.props.type) {
        case TYPE.PULLQUOTE:
          return PullquoteView;

        default:
          return BlockquoteView;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Comp = this.getComponent();
      return React__default.createElement(Comp, this.props);
    }
  }]);

  return QuoteCardView;
}(React.Component);

_defineProperty(QuoteCardView, "TYPE", TYPE);

_defineProperty(QuoteCardView, "FLOAT", FLOAT$1);

_defineProperty(QuoteCardView, "propTypes", propTypes$1);

var _QuoteCard = createCard({
  name: 'QuoteCard',
  renderWith: QuoteCardView
});

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  max-width: 760px;\n  padding: 0 20px;\n  @media screen and (min-width: 1280px) {\n    padding: 0 20px 0 40px;\n    float: right;\n    width: 50%;\n  }\n  @media screen and (min-width: 1720px) {\n    padding: 0;\n    width: 760px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " ", ";\n  max-width: 740px;\n  @media screen and (min-width: 600px) {\n    margin-bottom: 2rem;\n  }\n  @media screen and (min-width: 1280px) {\n    width: 47%;\n    max-width: 760px;\n    float: left;\n    margin: 0;\n    padding: 0 0 0 20px;\n  }\n  @media screen and (min-width: 1720px) {\n    padding: 0;\n    width: 760px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-width: 760px;\n  transition: 0.2s all ease-in-out;\n  @media screen and (min-width: 1280px) {\n    max-width: 760px;\n    &.sticky {\n      position: fixed;\n      top: 0;\n      margin-top: ", ";\n      width: calc(47% - 20px);\n      padding: 0;\n    }\n    &.sticky-bottom {\n      position: absolute;\n      bottom: 0;\n      top: auto;\n    }\n  }\n  @media screen and (min-width: 1720px) {\n    &.sticky {\n      width: auto;\n    }\n  }\n  img {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n    width: auto;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.2em;\n  font-weight: bold;\n  @media screen and (max-width: 800px) {\n    font-size: 1.2em;\n  }\n  @media screen and (max-width: 600px) {\n    font-size: 1em;\n  }\n  max-width: 760px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 2;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: ", ";\n  line-height: 1;\n  font-family: ", ";\n  position: relative;\n  z-index: 1;\n  font-size: 32px;\n  @media screen and (min-width: 800px) {\n    font-size: 60px;\n    line-height: 70px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 760px;\n  margin: 0 auto;\n  @media screen and (min-width: 1280px) {\n    max-width: 1680px;\n    position: relative;\n    &:after {\n      content: '';\n      display: table;\n      clear: both;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  padding: ", " 0;\n  header {\n    padding: 0 20px;\n    text-align: center;\n    margin-bottom: ", ";\n    @media screen and (max-width: 800px) {\n      margin-bottom: ", ";\n    }\n  }\n  @media screen and (max-width: 800px) {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding: ", " 0;\n    padding-bottom: 0;\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var Testimonial = styled.section(_templateObject$6(), crane.wide, function (_ref) {
  var theme = _ref.theme;
  return theme.testimonialBackgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.largeSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.largeSpacing;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.largeSpacing;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediumSpacing;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediumSpacing;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediumSpacing;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.mediumSpacing;
});
var Wrap = styled(reactSticky.StickyContainer)(_templateObject2());
var Title = styled.h1(_templateObject3(), function (_ref10) {
  var theme = _ref10.theme;
  return theme.brand ? theme.brand : theme.primaryColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.headerFontFamily;
});
var Intro = styled.p(_templateObject4());
var Image$1 = styled.figure(_templateObject5(), function (_ref13) {
  var theme = _ref13.theme;
  return theme.mediumSpacing;
});
var ImageWrap = styled.div(_templateObject6(), function (_ref14) {
  var theme = _ref14.theme;
  return theme.mediumSpacing;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.smallSpacing;
});
var ContentWrap = styled.div(_templateObject7());

var mediaUrl = function mediaUrl(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url) return null;
  if (!Object.keys(opts).length) return url;
  var w = opts.width,
      h = opts.height;
  return "".concat(url, "?").concat(qs.stringify({
    w: w,
    h: h,
    quality: w || h ? 100 : undefined
  }));
};

var TestimonialCard = /*#__PURE__*/function (_Component) {
  _inherits(TestimonialCard, _Component);

  function TestimonialCard() {
    _classCallCheck(this, TestimonialCard);

    return _possibleConstructorReturn(this, _getPrototypeOf(TestimonialCard).apply(this, arguments));
  }

  _createClass(TestimonialCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          intro = _this$props.intro,
          content = _this$props.content,
          url = _this$props.url,
          props = _objectWithoutProperties(_this$props, ["title", "intro", "content", "url"]);

      var sized = mediaUrl(url, {
        width: 760,
        height: 1280
      });
      return React__default.createElement(Testimonial, props, !(title || intro) ? null : React__default.createElement("header", null, !title ? null : React__default.createElement(Title, null, title), !intro ? null : React__default.createElement(Intro, null, intro)), React__default.createElement(Wrap, null, !sized ? null : React__default.createElement(ImageWrap, null, React__default.createElement(reactSticky.Sticky, {
        disableCompensation: true
      }, function (_ref16) {
        var sticky = _ref16.isSticky,
            distanceFromBottom = _ref16.distanceFromBottom;
        return React__default.createElement(Image$1, {
          className: classNames({
            sticky: sticky,
            'sticky-bottom': distanceFromBottom < 0
          })
        }, React__default.createElement("img", {
          src: sized,
          alt: "portret van ".concat(title)
        }));
      })), React__default.createElement(ContentWrap, null, React__default.createElement(MobiledocRenderer$1, {
        content: content,
        mini: true
      }))));
    }
  }]);

  return TestimonialCard;
}(React.Component);

_defineProperty(TestimonialCard, "defaultProps", {
  title: '',
  intro: '',
  mediaId: '',
  src: '',
  url: '',
  content: ''
});

var _TestimonialCard = createCard({
  name: 'TestimonialCard',
  renderWith: TestimonialCard
});

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  max-width: 1160px;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  margin-top: ", ";\n  margin-bottom: ", ";\n  .video-wrapper {\n    max-width: 1160px;\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    height: 0;\n    padding-bottom: 33%;\n  }\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  @media screen and (max-width: 800px) {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var Figure = styled.figure(_templateObject$7(), crane.wide, function (_ref) {
  var theme = _ref.theme;
  return theme.largeSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediumSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediumSpacing;
});

var getMatches = function getMatches(target, re) {
  return Object.keys(re).reduce(function (acc, key) {
    return _objectSpread$1({}, acc, _defineProperty({}, key, re[key].exec(target)));
  }, {});
};

var EmbedCard = /*#__PURE__*/function (_Component) {
  _inherits(EmbedCard, _Component);

  function EmbedCard(props) {
    var _this;

    _classCallCheck(this, EmbedCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmbedCard).call(this));

    _defineProperty(_assertThisInitialized(_this), "state", {
      percentage: 56
    });

    _this.determineDimensions(props);

    return _this;
  }

  _createClass(EmbedCard, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.determineDimensions(props);
    }
  }, {
    key: "determineDimensions",
    value: function determineDimensions() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      setTimeout(function () {
        var _getMatches = getMatches(props.html, {
          width: /width="(\d+)"/i,
          height: /height="(\d+)"/i
        }),
            width = _getMatches.width,
            height = _getMatches.height;

        var percentage = height / width * 100;

        _this2.setState({
          percentage: percentage
        });
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          html = _this$props.html,
          props = _objectWithoutProperties(_this$props, ["html"]);

      return React__default.createElement(Figure, props, React__default.createElement("div", {
        className: "video-wrapper",
        style: {
          paddingBottom: "".concat(this.state.percentage, "%")
        },
        dangerouslySetInnerHTML: {
          __html: html
        } // eslint-disable-line react/no-danger

      }));
    }
  }]);

  return EmbedCard;
}(React.Component);

_defineProperty(EmbedCard, "propTypes", {
  src: PropTypes.string,
  html: PropTypes.string
});

_defineProperty(EmbedCard, "defaultProps", {
  src: '',
  html: ''
});

var _EmbedCard = createCard({
  name: 'EmbedCard',
  renderWith: EmbedCard
});

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n          max-width: 100%;\n          padding: 0;\n        "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  color: black;\n  width: 100vw;\n  max-width: 1100px;\n  margin: 2rem auto;\n  transform: translateX(-50%);\n  margin-left: 50%;\n  padding: 0 20px;\n  line-height: ", ";\n  text-align: left;\n  font-weight: ", ";\n  font-size: ", "px;\n  @media screen and (min-width: 600px) {\n    font-size: ", "px;\n  }\n  @media screen and (min-width: 800px) {\n    font-size: ", "px;\n  }\n\n  ", "\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var Intro$1 = styled.div(_templateObject$8(), function (_ref) {
  var theme = _ref.theme;
  return theme.introLineHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.introFontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.introFontSize * 16;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.introFontSize * 18;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.introFontSize * 23;
}, function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return !fullWidth ? null : css(_templateObject2$1());
});

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  opacity: 0.3;\n  font-size: 80px;\n  font-weight: bold;\n  line-height: 55px;\n  font-family: ", ";\n  text-transform: ", ";\n  @media screen and (min-width: 800px) {\n    font-size: 110px;\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: ", ";\n  letter-spacing: 1.5px;\n  font-size: 30px;\n  line-height: 65px !important;\n  margin: -70px 0 30px 0;\n  @media screen and (min-width: 800px) {\n    font-size: 60px;\n    line-height: 70px;\n    margin: -85px 0 4rem;\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  max-width: 1140px;\n  margin: 0 auto;\n  padding: ", " 10px;\n  text-align: center;\n  margin: 0 auto;\n  * {\n    text-align: center;\n  }\n  @media screen and (max-width: 800px) {\n    padding: ", " 10px;\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 0;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  &:first-child {\n    margin-top: 0 !important;\n  }\n  @media screen and (max-width: 800px) {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject$9(), crane.wide, function (_ref) {
  var theme = _ref.theme;
  return theme.chapterBackgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.largeSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediumSpacing;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediumSpacing;
});
var IntroText = styled(Intro$1)(_templateObject2$2(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.chapterIntroColor;
});
var Chapter = styled.div(_templateObject3$1(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.largeSpacing;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediumSpacing;
});
var Title$1 = styled.h2(_templateObject4$1(), function (_ref9) {
  var theme = _ref9.theme;
  return theme.chapterItemColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});
var Marker = styled.span(_templateObject5$1(), function (_ref11) {
  var theme = _ref11.theme;
  return theme.chapterItemNumberColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.headerFontFamily;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});

var ChapterView = /*#__PURE__*/function (_Component) {
  _inherits(ChapterView, _Component);

  function ChapterView() {
    _classCallCheck(this, ChapterView);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChapterView).apply(this, arguments));
  }

  _createClass(ChapterView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          intro = _this$props.intro,
          marker = _this$props.marker,
          props = _objectWithoutProperties(_this$props, ["title", "intro", "marker"]);

      return React__default.createElement(Container, {
        className: "headerContainer",
        id: slugify(title)
      }, React__default.createElement(Chapter, props, React__default.createElement(Fade, {
        bottom: true,
        distance: "20px"
      }, React__default.createElement(Marker, null, marker)), React__default.createElement(Fade, {
        bottom: true,
        distance: "20px",
        delay: 100
      }, React__default.createElement(Title$1, null, title)), React__default.createElement(Fade, {
        bottom: true,
        distance: "20px",
        delay: 200
      }, React__default.createElement(IntroText, null, intro))));
    }
  }]);

  return ChapterView;
}(React.Component);

_defineProperty(ChapterView, "propTypes", {
  title: PropTypes.node,
  intro: PropTypes.node,
  marker: PropTypes.node
});

_defineProperty(ChapterView, "defaultProps", {
  title: '',
  intro: '',
  marker: ''
});

var _ChapterCard = createCard({
  name: 'ChapterCard',
  renderWith: ChapterView
});

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 20px;\n  background-color: ", ";\n  background-image: none;\n  color: ", ";\n  font-family: ", ";\n  padding: 20px 40px;\n  border-radius: 3px;\n  display: block;\n  margin-left: auto;\n  cursor: pointer;\n  position: relative;\n  font-weight: bold;\n  text-decoration: none;\n  transition: all 0.15s linear;\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n  @media screen and (max-width: 800px) {\n    margin-right: auto;\n    padding: 10px 20px;\n    width: 100%;\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  width: 100vw;\n  text-align: center;\n  .inner {\n    background: ", ";\n    padding: 40px;\n    margin: 0 auto;\n    max-width: 1160px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    > div {\n      width: 25%;\n      min-width: 25%;\n      max-width: 25%;\n      flex-basis: auto;\n      margin: 0;\n      padding: 0 10px;\n    }\n    > h2 {\n      width: 30%;\n      min-width: 30%;\n      max-width: 30%;\n      flex-basis: auto;\n      font-size: 32px;\n      color: ", ";\n      text-transform: uppercase;\n      text-align: center;\n      margin: 0;\n      padding: 0 10px;\n    }\n    > p {\n      width: 45%;\n      min-width: 45%;\n      max-width: 45%;\n      flex-basis: auto;\n      color: ", ";\n      text-align: left;\n      margin: 0;\n      padding: 0 10px;\n      font-size: 20px;\n    }\n  }\n  @media screen and (max-width: 800px) {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    .inner {\n      padding: 10px;\n      flex-direction: column;\n      > div,\n      > h2,\n      > p {\n        width: 100%;\n        min-width: 100%;\n        max-width: 100%;\n        padding: 10px;\n      }\n      > h2 {\n        font-size: 30px;\n        line-height: 38px;\n        text-align: center;\n      }\n      > p {\n        text-align: center;\n      }\n    }\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var CTA = styled.div(_templateObject$a(), crane.wide, function (_ref) {
  var theme = _ref.theme;
  return theme.largeSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primaryColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return crane.getContrastColor({
    backgroundColor: theme.primaryColor || '#ffffff',
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
}, function (_ref5) {
  var theme = _ref5.theme;
  return crane.getContrastColor({
    backgroundColor: theme.primaryColor || '#ffffff',
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediumSpacing;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediumSpacing;
});
var CTAButton = styled(crane.Button)(_templateObject2$3(), function (_ref8) {
  var theme = _ref8.theme;
  return theme.backgroundColorDark;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.textColorDark;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.headerFontFamily;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.iconHoverColor;
});

var CTACardView = /*#__PURE__*/function (_Component) {
  _inherits(CTACardView, _Component);

  function CTACardView() {
    _classCallCheck(this, CTACardView);

    return _possibleConstructorReturn(this, _getPrototypeOf(CTACardView).apply(this, arguments));
  }

  _createClass(CTACardView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          text = _this$props.text,
          actionText = _this$props.actionText,
          actionUrl = _this$props.actionUrl;
      return React__default.createElement(CTA, null, React__default.createElement("div", {
        className: "inner"
      }, React__default.createElement("h2", null, title), React__default.createElement("p", null, text), React__default.createElement("div", null, React__default.createElement(CTAButton, {
        as: "a",
        href: actionUrl
      }, actionText))));
    }
  }]);

  return CTACardView;
}(React.Component);

var _CTACard = createCard({
  name: 'CTACard',
  renderWith: CTACardView
});

var _DataCard = createCard({
  name: 'DataCard',
  renderWith: function renderWith() {
    React.useEffect(function () {
      return console.warn('[hummingbird] No `DataCard` shadow found: to use the `DataCard`, shadow it in `src/@wingscms/hummingbird/cards/DataCard`');
    }, []);
    return null;
  }
});

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 10px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  > svg {\n    width: 17px;\n    height: 17px;\n    margin: 10px 5px;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  @media screen and (max-width: 900px) {\n    text-align: center;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  a {\n    background-image: none;\n  }\n  & > * {\n    display: inline;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 800;\n  text-align: center;\n  padding: 0;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin-bottom: 10px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 20px;\n  background-color: ", ";\n  position: relative;\n  margin-bottom: 30px;\n  height: auto;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  line-height: 25px;\n  font-size: 16px;\n  margin-top: 10px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: left;\n  padding: 0;\n  @media screen and (max-width: 900px) {\n    text-align: center;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  max-width: 70%;\n  vertical-align: middle;\n  padding: 0 20px;\n  @media screen and (max-width: 900px) {\n    max-width: 100%;\n    text-align: center;\n  }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  max-width: 30%;\n  vertical-align: middle;\n  margin-bottom: 0;\n  @media screen and (max-width: 900px) {\n    max-width: 100%;\n    margin-bottom: 10px;\n  }\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 20px;\n  background-color: ", ";\n  position: relative;\n  margin-bottom: 30px;\n  height: auto;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 40px;\n  line-height: 42px;\n  font-weight: bold;\n  @media screen and (max-width: 645px) {\n    font-size: 24px;\n    line-height: 30px;\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: 1200px;\n  padding: 0 20px;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var Facebook = crane.Icons.Facebook,
    Globe = crane.Icons.Globe,
    Instagram = crane.Icons.Instagram,
    Linkedin = crane.Icons.Linkedin,
    Twitter = crane.Icons.Twitter;
var Wide = styled.div(_templateObject$b(), crane.wide);
var WideContentWrap = styled.div(_templateObject2$4());
var Title$2 = styled.h3(_templateObject3$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.textColor;
});
var OrganisationContainer = styled.div(_templateObject4$2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.elementBackgroundColor;
});
var OrganisationImage = styled.img(_templateObject5$2());
var OrganisationContent = styled.div(_templateObject6$1());
var OrganisationName = styled.h3(_templateObject7$1(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.textColor;
});
var OrganisationDescription = styled.p(_templateObject8());
var PersonContainer = styled.div(_templateObject9(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.elementBackgroundColor;
});
var PersonImg = styled.img(_templateObject10());
var PersonName = styled.h3(_templateObject11(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.textColor;
});
var ProfilesWrapper = styled.div(_templateObject12());
var OrgProfilesWrapper = styled(ProfilesWrapper)(_templateObject13());
var ProfileImage = styled.div(_templateObject14());
var StyledFlexGrid = styled(crane.FlexGrid)(_templateObject15(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.appBackgroundColor;
});

var CollectionCardView = /*#__PURE__*/function (_Component) {
  _inherits(CollectionCardView, _Component);

  function CollectionCardView() {
    _classCallCheck(this, CollectionCardView);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollectionCardView).apply(this, arguments));
  }

  _createClass(CollectionCardView, [{
    key: "mapOrganisations",
    value: function mapOrganisations() {
      return this.props.items.map(function (x, i) {
        return (// eslint-disable-next-line
          React__default.createElement(OrganisationContainer, {
            key: x._id,
            index: i
          }, x.image ? React__default.createElement(OrganisationImage, {
            src: x.image.url
          }) : null, React__default.createElement(OrganisationContent, null, x.name ? React__default.createElement(OrganisationName, null, x.name) : null, x.description ? React__default.createElement(OrganisationDescription, null, x.description.text) : null, x.profiles && React__default.createElement(OrgProfilesWrapper, null, x.profiles.website ? React__default.createElement("a", {
            href: x.profiles.website.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Globe, null))) : null, x.profiles.facebook ? React__default.createElement("a", {
            href: x.profiles.facebook.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Facebook, null))) : null, x.profiles.linkedIn ? React__default.createElement("a", {
            href: x.profiles.linkedIn.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Linkedin, null))) : null, x.profiles.instagram ? React__default.createElement("a", {
            href: "https://www.instagram.com/".concat(x.profiles.instagram.username),
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Instagram, null))) : null, x.profiles.twitter ? React__default.createElement("a", {
            href: "http://www.twitter.com/".concat(x.profiles.twitter.username),
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Twitter, null))) : null)))
        );
      });
    }
  }, {
    key: "mapPersons",
    value: function mapPersons() {
      return this.props.items.map(function (x, i) {
        return (// eslint-disable-next-line
          React__default.createElement(PersonContainer, {
            key: x._id,
            index: i
          }, x.image ? React__default.createElement(PersonImg, {
            src: x.image.url
          }) : null, x.name ? React__default.createElement(PersonName, null, x.name) : null, x.profiles ? React__default.createElement(ProfilesWrapper, null, x.profiles.website ? React__default.createElement("a", {
            href: x.profiles.website.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Globe, null))) : null, x.profiles.facebook ? React__default.createElement("a", {
            href: x.profiles.facebook.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Facebook, null))) : null, x.profiles.linkedIn ? React__default.createElement("a", {
            href: x.profiles.linkedIn.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Linkedin, null))) : null, x.profiles.instagram ? React__default.createElement("a", {
            href: "https://www.instagram.com/".concat(x.profiles.instagram.username),
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Instagram, null))) : null, x.profiles.twitter ? React__default.createElement("a", {
            href: "http://www.twitter.com/".concat(x.profiles.twitter.username),
            target: "_blank",
            rel: "noopener noreferrer"
          }, React__default.createElement(ProfileImage, null, React__default.createElement(Twitter, null))) : null) : null)
        );
      });
    }
  }, {
    key: "returnCollection",
    value: function returnCollection() {
      switch (this.props.type) {
        case 0:
          return this.renderPersonsCollection();

        case 1:
          return this.renderOrganisationsCollection();

        default:
          return null;
      }
    }
  }, {
    key: "renderPersonsCollection",
    value: function renderPersonsCollection() {
      return React__default.createElement(React__default.Fragment, null, this.props.title ? React__default.createElement(Title$2, null, this.props.title) : null, React__default.createElement(Wide, null, React__default.createElement(WideContentWrap, null, React__default.createElement(StyledFlexGrid, {
        divisions: 4,
        margins: 10,
        alignItems: "stretch",
        style: {
          width: '100%'
        }
      }, this.mapPersons()))));
    }
  }, {
    key: "renderOrganisationsCollection",
    value: function renderOrganisationsCollection() {
      return React__default.createElement(React__default.Fragment, null, this.props.title ? React__default.createElement(Title$2, null, this.props.title) : null, React__default.createElement(StyledFlexGrid, {
        divisions: 1,
        margins: 10,
        alignItems: "stretch",
        style: {
          marginLeft: '-20px',
          width: 'calc(100% + 40px)'
        }
      }, this.mapOrganisations()));
    }
  }, {
    key: "render",
    value: function render() {
      return this.returnCollection();
    }
  }]);

  return CollectionCardView;
}(React.Component);

var _CollectionCard = createCard({
  name: 'CollectionCard',
  renderWith: CollectionCardView
});

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  width: 20px;\n  height: auto;\n  transform: translateY(-50%);\n  fill: ", ";\n  svg {\n    width: 100%;\n    height: auto;\n  }\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n  transition: all 0.2s ease-in-out;\n  padding-right: 60px;\n  p {\n    font-weight: bold;\n    transition: all 0.2s ease-in-out;\n  }\n  &:hover {\n    background-color: ", ";\n    p {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  &:last-child {\n    border-bottom: none;\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  box-shadow: ", ";\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 20px;\n  p {\n    margin-bottom: 0;\n  }\n  @media screen and (max-width: 800px) {\n    width: 100%;\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  text-transform: ", ";\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 42px;\n\n  @media screen and (max-width: 645px) {\n    font-size: 24px;\n    line-height: 30px;\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " 0;\n  @media screen and (min-width: 800px) {\n    margin: ", " 0;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var Container$1 = styled.div(_templateObject$c(), function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
});
var Title$3 = styled.h3(_templateObject2$5(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});
var Text = styled.div(_templateObject3$3());
var QA = styled.div(_templateObject4$3(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.defaultShadow;
});
var QuestionWrapper = styled.div(_templateObject5$3(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.elementBackgroundColor;
});
var QuestionText = styled.div(_templateObject6$2(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.elementBackgroundColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return crane.getContrastColor({
    backgroundColor: theme.elementBackgroundColor,
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
});
var AnswerText = styled.div(_templateObject7$2(), function (_ref8) {
  var show = _ref8.show;
  return show ? 'block' : 'none';
});
var Icon = styled.div(_templateObject8$1(), function (_ref9) {
  var theme = _ref9.theme;
  return theme.primaryColor;
});

var Question = function Question(_ref10) {
  var question = _ref10.question,
      answer = _ref10.answer;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  return React__default.createElement(QuestionWrapper, null, React__default.createElement(QuestionText, {
    onClick: function onClick() {
      return setShow(!show);
    },
    show: show
  }, React__default.createElement(Icon, null, show ? React__default.createElement(crane.Icons.ChevronUp, null) : React__default.createElement(crane.Icons.ChevronDown, null)), React__default.createElement(Text, null, React__default.createElement(MobiledocRenderer$1, {
    content: question,
    mini: true
  }))), React__default.createElement(AnswerText, {
    show: show
  }, React__default.createElement(Text, null, React__default.createElement(MobiledocRenderer$1, {
    content: answer,
    mini: true
  }))));
};

var QACardView = /*#__PURE__*/function (_Component) {
  _inherits(QACardView, _Component);

  function QACardView() {
    _classCallCheck(this, QACardView);

    return _possibleConstructorReturn(this, _getPrototypeOf(QACardView).apply(this, arguments));
  }

  _createClass(QACardView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          title = _this$props.title;
      return React__default.createElement(Container$1, null, title ? React__default.createElement(Title$3, null, title) : null, React__default.createElement(QA, null, content.map(function (x) {
        return React__default.createElement(Question, {
          question: x.question,
          answer: x.answer,
          key: "qacard-".concat(x._id)
        });
      })));
    }
  }]);

  return QACardView;
}(React.Component);

var _QACard = createCard({
  name: 'QACard',
  renderWith: QACardView
});

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " 0;\n  padding: 30px;\n  box-shadow: ", ";\n  background-color: ", ";\n  p {\n    font-size: 0.9em;\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var TextWrapper = styled.div(_templateObject$d(), function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.defaultShadow;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.elementBackgroundColor;
});

var TextCardView = /*#__PURE__*/function (_Component) {
  _inherits(TextCardView, _Component);

  function TextCardView() {
    _classCallCheck(this, TextCardView);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextCardView).apply(this, arguments));
  }

  _createClass(TextCardView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          props = _objectWithoutProperties(_this$props, ["content"]);

      return React__default.createElement(TextWrapper, props, React__default.createElement(MobiledocRenderer$1, {
        content: content,
        mini: true
      }));
    }
  }]);

  return TextCardView;
}(React.Component);

var _TextCard = createCard({
  name: 'TextCard',
  renderWith: TextCardView
});

var _FIELD_COPY_MAPPING;

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  width: 50px;\n  vertical-align: middle;\n  margin: 0 5px;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  background-color: #000;\n  color: #fff;\n  margin-top: 40px;\n  width: auto;\n\n  &:after {\n    display: none;\n  }\n  &:hover {\n    text-decoration: none;\n    color: ", ";\n  }\n  @media screen and (max-width: 800px) {\n    font-size: 22px;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var patchSchema = function patchSchema(schema, fieldDefinitions) {
  return deepmerge(schema, {
    properties: fieldDefinitions
  });
};

var SIGNUP_QUERY = "\n  query ($selector: SignupSelectorInput) {\n    campaign: signup(selector: $selector) {\n      id\n      title\n      submissionSchema\n      settings {\n        legal {\n          terms {\n            url\n          }\n          privacyPolicy {\n            url\n          }\n        }\n      }\n      ...NodeFields\n      ...CampaignFields\n    }\n  }\n";
var SIGNUP_MUTATION = "\n  mutation SubmitSignup($input: SubmitSignupInput!) {\n    submitSignup(input: $input) {\n      submission {\n        id\n      }\n    }\n  }\n";
var PETITION_QUERY = "\n  query ($selector: PetitionSelectorInput) {\n    campaign: petition(selector: $selector) {\n      id\n      title\n      submissionSchema\n      settings {\n        legal {\n          terms {\n            url\n          }\n          privacyPolicy {\n            url\n          }\n        }\n      }\n      signatureCount\n      signatureGoal\n      ...NodeFields\n      ...CampaignFields\n    }\n  }\n";
var PETITION_MUTATION = "\n  mutation SubmitPetition($input: SubmitPetitionInput!) {\n    submitPetition(input: $input) {\n      signature {\n        id\n      }\n    }\n  }\n";
var EVENT_QUERY = "\n  query ($selector: EventSelectorInput) {\n    campaign: event(selector: $selector) {\n      id\n      title\n      submissionSchema\n      settings {\n        legal {\n          terms {\n            url\n          }\n          privacyPolicy {\n            url\n          }\n        }\n      }\n      schedule {\n        start\n        end\n      }\n      location {\n        name\n        street\n        city\n        zip\n        country\n      }\n      fee {\n        amount {\n          amount\n          currency {\n            id\n            name\n            symbol\n          }\n        }\n      }\n      ...NodeFields\n      ...CampaignFields\n    }\n  }\n";
var EVENT_MUTATION = "\n  mutation SubmitEvent($input: SubmitEventInput!) {\n    submitEvent(input: $input) {\n      attendee {\n        id\n      }\n    }\n  }\n";
var FUNDRAISER_QUERY = "\n  query ($selector: FundraiserSelectorInput) {\n    campaign: fundraiser(selector: $selector) {\n      id\n      title\n      submissionSchema\n      settings {\n        legal {\n          terms {\n            url\n          }\n          privacyPolicy {\n            url\n          }\n        }\n      }\n      target {\n        amount\n        currency {\n          id\n          name\n          symbol\n        }\n      }\n      amounts {\n        options {\n          amount {\n            amount\n            currency {\n              id\n              name\n              symbol\n            }\n          }\n        }\n      }\n      raised {\n        amount\n        currency {\n          id\n          name\n          symbol\n        }\n      }\n      paymentMethods {\n        id\n        title\n        icons {\n          url\n        }\n      }\n      ...NodeFields\n      ...CampaignFields\n    }\n  }\n";
var FUNDRAISER_MUTATION = "\n  mutation SubmitFundraiser($input: SubmitFundraiserInput!) {\n    submitFundraiser(input: $input) {\n      donation {\n        id\n        order {\n          id\n          paymentUrl\n        }\n      }\n    }\n  }\n";
var Button = styled(crane.Button)(_templateObject$e(), function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
});
var PaymentMethodIcon = styled.img(_templateObject2$6());
var FIELDS = {
  EMAIL: 'email',
  FIRSTNAME: 'firstName',
  LASTNAME: 'lastName',
  NEWSLETTER: 'newsletter',
  PRIVACY: 'privacyConsent',
  TERMS: 'terms',
  ADDRESS: 'address',
  ZIPCODE: 'zipcode',
  CITY: 'city',
  COUNTRY: 'country',
  PHONE: 'phone',
  AMOUNT: 'amount'
};
var FIELD_COPY_MAPPING = (_FIELD_COPY_MAPPING = {}, _defineProperty(_FIELD_COPY_MAPPING, FIELDS.EMAIL, 'emailFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.FIRSTNAME, 'firstNameFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.LASTNAME, 'lastNameFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.NEWSLETTER, 'newsletterFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.PRIVACY, 'privacyConsentFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.TERMS, 'termsFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.ADDRESS, 'addressFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.ZIPCODE, 'zipcodeFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.CITY, 'cityFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.COUNTRY, 'countryFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.PHONE, 'phoneFieldLabel'), _defineProperty(_FIELD_COPY_MAPPING, FIELDS.AMOUNT, 'amountFieldLabel'), _FIELD_COPY_MAPPING);
var DEFAULT_COPY = {
  submitText: 'Submit',
  eventSubmitText: 'Attend',
  fundraiserSubmitText: 'Donate',
  signupSubmitText: 'Submit',
  petitionSubmitText: 'Sign',
  emailFieldLabel: 'Email address',
  firstNameFieldLabel: 'First name',
  lastNameFieldLabel: 'Last name',
  addressFieldLabel: 'Address',
  zipcodeFieldLabel: 'Postcode',
  cityFieldLabel: 'City',
  countryFieldLabel: 'Country',
  phoneFieldLabel: 'Phone number',
  amountFieldLabel: 'Amount',
  newsletterFieldLabel: 'Stay up to date',
  termsFieldLabel: 'Agree to our terms & conditions',
  privacyConsentFieldLabel: 'Agree to our privacy policy',
  campaignConfirmTitle: 'We’re almost there!',
  campaignConfirmText: 'We have sent you an email with a confirmation link to make sure all signatures are genuine. If you follow that link, your signature will count. Thanks!',
  campaignLoadingText: 'loading',
  campaignErrorTitle: 'Oops!',
  campaignErrorText: 'Something went wrong with the submitting the form. Try again or report the issue to us.',
  campaignErrorButtonText: 'Try again'
};

var CampaignForm = /*#__PURE__*/function (_Component) {
  _inherits(CampaignForm, _Component);

  function CampaignForm(props) {
    var _this;

    _classCallCheck(this, CampaignForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CampaignForm).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      campaign: null,
      fetching: false,
      formSchema: null,
      amount: 0,
      paymentMethod: null,
      stage: 'form',
      submitLoading: false
    });

    _defineProperty(_assertThisInitialized(_this), "maybeEmitOnLoad", function () {
      var campaign = _this.state.campaign;
      if (campaign) _this.props.onLoad(campaign);
    });

    _defineProperty(_assertThisInitialized(_this), "query", function () {
      switch (_this.props.type) {
        case 'signup':
          return SIGNUP_QUERY;

        case 'petition':
          return PETITION_QUERY;

        case 'event':
          return EVENT_QUERY;

        case 'fundraiser':
          return FUNDRAISER_QUERY;

        default:
          return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "mutation", function () {
      switch (_this.props.type) {
        case 'signup':
          return SIGNUP_MUTATION;

        case 'petition':
          return PETITION_MUTATION;

        case 'event':
          return EVENT_MUTATION;

        case 'fundraiser':
          return FUNDRAISER_MUTATION;

        default:
          return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "processSchema", function (s) {
      var disabledFields = _this.props.disabledFields;

      var schema = _objectSpread$2({}, s, {
        properties: _objectSpread$2({}, s.properties)
      });

      disabledFields.forEach(function (field) {
        delete schema.properties[field];
      });
      schema.required = schema.required.filter(function (f) {
        return disabledFields.indexOf(f) < 0;
      });
      return _this.props.processSchema(_this._overrideSchemaCopy(schema), _this._getHookContext());
    });

    _defineProperty(_assertThisInitialized(_this), "processSubmission", function (sub) {
      var disabledFields = _this.props.disabledFields;

      var submission = _objectSpread$2({}, sub);

      disabledFields.forEach(function (field) {
        submission[field] = true;
      });
      return _this.props.processSubmission(submission, _this._getHookContext());
    });

    _defineProperty(_assertThisInitialized(_this), "_getHookContext", function () {
      return {
        node: _this.state.campaign || _this.props.node
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2, event) {
        var fd, formData, onSubmitRes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fd = _ref2.formData;
                _context.prev = 1;
                formData = _this.processSubmission(fd);

                if (!_this.props.onSubmit) {
                  _context.next = 11;
                  break;
                }

                _context.next = 6;
                return _this.props.onSubmit(formData, _objectSpread$2({
                  event: event
                }, _this._getHookContext()));

              case 6:
                onSubmitRes = _context.sent;

                if (!onSubmitRes) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return _this.submit(formData);

              case 10:
                return _context.abrupt("return");

              case 11:
                _context.next = 13;
                return _this.submit(formData);

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);

                _this.setState({
                  stage: 'error'
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 15]]);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handlePaymentMethodChange", function (e) {
      _this.setState({
        selectedPaymentMethod: e.target.value
      });
    });

    _this.confirmedContainerRef = React__default.createRef();
    return _this;
  }

  _createClass(CampaignForm, [{
    key: "getCopy",
    value: function getCopy() {
      return _objectSpread$2({}, DEFAULT_COPY, {}, this.props.copy);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.maybeFetch();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.maybeFetch();
    }
  }, {
    key: "getFormSchema",
    value: function getFormSchema() {
      var schema = this.props.formSchema || this.props.node.submissionSchema && JSON.parse(this.props.node.submissionSchema) || this.state.formSchema;
      return schema ? this.processSchema(schema) : schema;
    }
  }, {
    key: "_overrideSchemaCopy",
    value: function _overrideSchemaCopy(schema) {
      var fields = Object.values(FIELDS).filter(function (f) {
        return Object.keys(schema.properties).indexOf(f) > -1;
      });
      var copy = this.getCopy();
      var fieldDefs = fields.reduce(function (defs, field) {
        return _objectSpread$2({}, defs, _defineProperty({}, field, {
          title: copy[FIELD_COPY_MAPPING[field]]
        }));
      }, {});
      return patchSchema(schema, fieldDefs);
    }
  }, {
    key: "getSubmitText",
    value: function getSubmitText() {
      var _this$props = this.props,
          type = _this$props.type,
          _this$props$submitTex = _this$props.submitText,
          submitText = _this$props$submitTex === void 0 ? '' : _this$props$submitTex;

      var _this$getCopy = this.getCopy(),
          signupSubmitText = _this$getCopy.signupSubmitText,
          eventSubmitText = _this$getCopy.eventSubmitText,
          petitionSubmitText = _this$getCopy.petitionSubmitText,
          fundraiserSubmitText = _this$getCopy.fundraiserSubmitText,
          defaultSubmitText = _this$getCopy.defaultSubmitText;

      if (submitText) return submitText;

      switch (type) {
        case 'signup':
          return signupSubmitText;

        case 'event':
          return eventSubmitText;

        case 'petition':
          return petitionSubmitText;

        case 'fundraiser':
          return fundraiserSubmitText;

        default:
          return defaultSubmitText;
      }
    }
  }, {
    key: "fragment",
    value: function fragment() {
      return [this.props.nodeFragment, this.props.campaignFragment].join('\n');
    }
  }, {
    key: "maybeFetch",
    value: function maybeFetch() {
      var _this2 = this;

      if (this.state.failed || this.state.formSchema || this.props.formSchema || this.state.fetching) {
        return;
      }

      this.setState({
        fetching: true
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var campaign, formSchema, failed, _ref5, c;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                failed = false;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.props.wings.query(_this2.query() + _this2.fragment(), {
                  selector: {
                    id: {
                      eq: _this2.props.id
                    }
                  }
                });

              case 4:
                _ref5 = _context2.sent;
                c = _ref5.campaign;
                campaign = c;
                formSchema = JSON.parse(c.submissionSchema); // console.log(campaign);

                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                console.error("Couldn't fetch submission schema for campaign", _this2.props.type, _this2.props.id);
                failed = true;

              case 14:
                _context2.prev = 14;

                _this2.setState(_objectSpread$2({
                  fetching: false,
                  formSchema: formSchema,
                  campaign: campaign,
                  failed: failed
                }, campaign.resourceType === 'node.fundraiser' && {
                  amount: campaign.amounts.options[0].amount.amount,
                  selectedPaymentMethod: campaign.paymentMethods[0].id
                }), _this2.maybeEmitOnLoad);

                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 10, 14, 17]]);
      })));
    }
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formData) {
        var _this$state, amount, paymentMethod, res, paymentUrl;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$state = this.state, amount = _this$state.amount, paymentMethod = _this$state.selectedPaymentMethod;
                _context3.prev = 1;
                this.setState({
                  submitLoading: true
                });
                _context3.next = 5;
                return this.props.wings.query(this.mutation(), {
                  input: _objectSpread$2({
                    id: this.props.id,
                    data: JSON.stringify(formData)
                  }, this.props.type === 'fundraiser' && {
                    amount: amount,
                    paymentMethod: paymentMethod
                  }, {
                    redirectUrl: this.props.redirectUrl // default to current URL?

                  })
                });

              case 5:
                res = _context3.sent;

                if (res.submitFundraiser && res.submitFundraiser.donation && res.submitFundraiser.donation.id) {
                  paymentUrl = res.submitFundraiser.donation.order.paymentUrl;
                  if (!paymentUrl) this.setState({
                    stage: 'error'
                  });else window.location.assign(paymentUrl);
                } else {
                  this.setState({
                    stage: 'confirm'
                  });
                }

                this.confirmedContainerRef.current.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](1);
                console.error(_context3.t0);

              case 13:
                _context3.prev = 13;
                this.setState({
                  submitLoading: false
                });
                return _context3.finish(13);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 10, 13, 16]]);
      }));

      function submit(_x3) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "getCurrencySymbol",
    value: function getCurrencySymbol(fundraiser) {
      var amounts = fundraiser.amounts.options;
      return amounts.length ? amounts[0].amount.currency.symbol : '';
    }
  }, {
    key: "getCampaign",
    value: function getCampaign() {
      return this.state.campaign || this.props.node;
    }
  }, {
    key: "renderAmount",
    value: function renderAmount() {
      var _this3 = this;

      var amount = this.state.amount;
      var campaign = this.getCampaign();
      var amounts = campaign.amounts.options.map(function (o) {
        return o.amount.amount;
      });
      var symbol = this.getCurrencySymbol(campaign);

      var _this$getCopy2 = this.getCopy(),
          amountFieldLabel = _this$getCopy2.amountFieldLabel;

      return React__default.createElement("div", {
        style: {
          marginBottom: '20px'
        }
      }, React__default.createElement(SchemaForm._Amount, {
        label: amountFieldLabel,
        required: true,
        id: "amount",
        symbol: symbol,
        value: amount,
        amounts: amounts,
        onChange: function onChange(v) {
          _this3.setState({
            amount: v
          });
        }
      }));
    }
  }, {
    key: "renderPaymentMethodSelect",
    value: function renderPaymentMethodSelect() {
      var _this4 = this;

      var fundraiser = this.getCampaign();
      var paymentMethods = fundraiser.paymentMethods;
      return React__default.createElement("div", null, paymentMethods.map(function (method) {
        return React__default.createElement("div", {
          style: {
            marginTop: '10px'
          }
        }, React__default.createElement("label", {
          style: {
            fontSize: '16px',
            verticalAlign: 'middle'
          }
        }, React__default.createElement("input", {
          type: "radio",
          id: "payment-menthod-".concat(method.id.replace('_', '-')),
          key: "payment-menthod-".concat(method.id),
          name: "payment-method",
          value: method.id,
          checked: _this4.state.selectedPaymentMethod === method.id,
          onChange: _this4.handlePaymentMethodChange,
          style: {
            marginRight: '20px'
          }
        }), method.icons.map(function (icon) {
          return React__default.createElement(PaymentMethodIcon, {
            src: icon.url,
            alt: method.title
          });
        })));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$state2 = this.state,
          stage = _this$state2.stage,
          submitLoading = _this$state2.submitLoading;
      var schema = this.getFormSchema();
      var loading = !schema;

      var _this$getCopy3 = this.getCopy(),
          campaignConfirmText = _this$getCopy3.campaignConfirmText,
          campaignConfirmTitle = _this$getCopy3.campaignConfirmTitle,
          campaignLoadingText = _this$getCopy3.campaignLoadingText,
          campaignErrorTitle = _this$getCopy3.campaignErrorTitle,
          campaignErrorText = _this$getCopy3.campaignErrorText,
          campaignErrorButtonText = _this$getCopy3.campaignErrorButtonText;

      return loading ? React__default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, campaignLoadingText, React__default.createElement(crane.Loading, null)) : React__default.createElement(React__default.Fragment, null, this.props.type === 'fundraiser' ? this.renderAmount() : null, !(stage === 'form') ? null : React__default.createElement(SchemaForm, _extends({
        id: "campaign-form",
        autoValidate: false
      }, this.props.schemaFormProps, {
        schema: schema,
        formData: this.state.formData,
        onChange: function onChange(_ref6) {
          var formData = _ref6.formData;
          return _this5.setState({
            formData: formData
          });
        },
        onSubmit: this.handleSubmit.bind(this)
      }), this.props.type === 'fundraiser' ? this.renderPaymentMethodSelect() : null, this.props.children || React__default.createElement(Button, {
        loading: submitLoading,
        intent: "primary"
      }, this.getSubmitText())), !(stage === 'confirm') ? null : React__default.createElement("div", {
        ref: this.confirmedContainerRef
      }, React__default.createElement("h1", null, campaignConfirmTitle), React__default.createElement("p", null, campaignConfirmText)), !(stage === 'error') ? null : React__default.createElement("div", null, React__default.createElement("h1", null, campaignErrorTitle), React__default.createElement("p", null, campaignErrorText), React__default.createElement(Button, {
        onClick: function onClick() {
          return _this5.setState({
            stage: 'form'
          });
        }
      }, campaignErrorButtonText)));
    }
  }]);

  return CampaignForm;
}(React.Component);

_defineProperty(CampaignForm, "propTypes", {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['signup', 'petition', 'event', 'fundraiser']).isRequired,
  onSubmit: PropTypes.func,
  processSchema: PropTypes.func,
  processSubmission: PropTypes.func,
  onLoad: PropTypes.func,
  disabledFields: PropTypes.array,
  schemaFormProps: PropTypes.object,
  nodeFragment: PropTypes.string,
  campaignFragment: PropTypes.string,
  node: PropTypes.shape({
    submissionSchema: PropTypes.string
  }),
  copy: PropTypes.object
});

_defineProperty(CampaignForm, "defaultProps", {
  onSubmit: null,
  processSchema: function processSchema(s) {
    return s;
  },
  processSubmission: function processSubmission(s) {
    return s;
  },
  onLoad: function onLoad(v) {
    return console.log('onLoad', v);
  },
  disabledFields: [],
  schemaFormProps: {},
  nodeFragment: "\n      fragment NodeFields on Node {\n        id\n      }\n    ",
  campaignFragment: "  \n      fragment CampaignFields on Campaign {\n        id\n      }\n    ",
  node: {},
  copy: {}
});

var CampaignForm$1 = withWings(CampaignForm);

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n  font-weight: 800;\n  font-family: 'Open Sans', Arial, sans-serif;\n  font-weight: bold;\n  margin-top: 10px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 20px;\n  padding: 0 10px;\n  min-width: 30%;\n  width: auto;\n  max-width: initial;\n  display: block;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 44px;\n  font-weight: 800;\n  font-family: 'Open Sans', Arial, sans-serif;\n  font-weight: bold;\n  max-width: 70%;\n  width: auto;\n  display: block;\n  line-height: 38px;\n  text-align: right;\n  padding-top: 2px;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n  align-items: center;\n  min-height: 80px;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  width: 100%;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var Container$2 = styled.div(_templateObject$f());
var TopContainer = styled.div(_templateObject2$7());
var CurrentText = styled.div(_templateObject3$4());
var DescriptionText = styled.div(_templateObject4$4());
var GoalText = styled.div(_templateObject5$4());

var PetitionCounter = /*#__PURE__*/function (_Component) {
  _inherits(PetitionCounter, _Component);

  function PetitionCounter() {
    _classCallCheck(this, PetitionCounter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PetitionCounter).apply(this, arguments));
  }

  _createClass(PetitionCounter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          current = _this$props.current,
          goal = _this$props.goal,
          goalText = _this$props.goalText,
          descriptionText = _this$props.descriptionText,
          symbol = _this$props.symbol;
      console.log(goal);
      return React__default.createElement(Container$2, null, React__default.createElement(TopContainer, null, React__default.createElement(CurrentText, null, symbol ? symbol : '', React__default.createElement(CountUp, {
        end: current,
        duration: 1.5
      })), React__default.createElement(DescriptionText, null, descriptionText)), !goal ? null : React__default.createElement(React__default.Fragment, null, React__default.createElement(crane.Counter, {
        intent: "primary",
        current: current,
        max: goal
      }), React__default.createElement(GoalText, null, goalText)));
    }
  }]);

  return PetitionCounter;
}(React.Component);

_defineProperty(PetitionCounter, "defaultProps", {
  current: 0
});

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  width: calc(100% - 20px);\n  max-width: 800px;\n  margin: 0 auto ", " auto;\n  padding: 20px;\n  background-color: #fff !important;\n  border-radius: 4px;\n  box-shadow: ", ";\n  text-align: center;\n  @media screen and (max-width: 800px) {\n    padding: 40px;\n    margin: ", " auto\n      ", " auto;\n  }\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 50%;\n  font-size: 18px;\n  font-weight: normal;\n  vertical-align: top;\n  p {\n    margin: 0;\n  }\n  text-align: left;\n  @media screen and (max-width: 800px) {\n    width: 100%;\n  }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-transform: ", ";\n  display: inline-block;\n  width: 50%;\n  font-size: 18px;\n  font-weight: bold;\n  vertical-align: top;\n  text-align: left;\n  @media screen and (max-width: 800px) {\n    width: 100%;\n  }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 0;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n  @media screen and (max-width: 800px) {\n    padding: 10px;\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var InfoContainer = styled.div(_templateObject$g());
var MetaContainer = styled.div(_templateObject2$8());
var MetaName = styled.div(_templateObject3$5(), function (_ref) {
  var theme = _ref.theme;
  return theme.headerFontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});
var MetaContent = styled.div(_templateObject4$5());
var Wrapper = styled.div(_templateObject5$5(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.largeSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.defaultShadow;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediumSpacing;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediumSpacing;
});

var EventDetails = function EventDetails(_ref7) {
  var title = _ref7.title,
      location = _ref7.location,
      eventStartLabel = _ref7.eventStartLabel,
      eventEndLabel = _ref7.eventEndLabel,
      eventLocationLabel = _ref7.eventLocationLabel,
      eventFeeLabel = _ref7.eventFeeLabel,
      eventStartTime = _ref7.eventStartTime,
      eventEndTime = _ref7.eventEndTime,
      eventFee = _ref7.eventFee;
  return React__default.createElement(Wrapper, null, title, React__default.createElement(InfoContainer, null, eventStartTime ? React__default.createElement(MetaContainer, null, React__default.createElement(MetaName, null, eventStartLabel), React__default.createElement(MetaContent, null, eventStartTime)) : null, eventEndTime ? React__default.createElement(MetaContainer, null, React__default.createElement(MetaName, null, eventEndLabel), React__default.createElement(MetaContent, null, eventEndTime)) : null, location ? React__default.createElement(MetaContainer, null, React__default.createElement(MetaName, null, eventLocationLabel), React__default.createElement(MetaContent, null, location.name ? React__default.createElement("p", null, location.name) : null, location.street ? React__default.createElement("p", null, location.street) : null, location.city ? React__default.createElement("p", null, location.city) : null, location.zip ? React__default.createElement("p", null, location.zip) : null, location.country ? React__default.createElement("p", null, location.country) : null)) : null, eventFee ? React__default.createElement(MetaContainer, null, React__default.createElement(MetaName, null, eventFeeLabel), React__default.createElement(MetaContent, null, eventFee)) : null));
};

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  font-size: 24px;\n  line-height: 28px;\n  padding: 20px 0;\n  font-family: ", ";\n  text-transform: ", ";\n  font-weight: bold;\n  bottom: 0;\n  left: 0;\n  border-radius: 4px;\n  z-index: 10;\n  background-color: #fff;\n  cursor: pointer;\n  &:hover {\n    color: ", ";\n  }\n  &::before {\n    content: '';\n    position: absolute;\n    z-index: 5;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100px;\n    transform: translateY(-100%);\n    background: linear-gradient(\n      to top,\n      rgba(255, 255, 255, 1),\n      rgba(255, 255, 255, 0) 50%\n    );\n  }\n  @media screen and (max-width: 1000px) {\n    display: ", ";\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  width: calc(100% - 460px);\n  padding: 40px 40px\n    ", "\n    40px;\n  margin: 40px 0;\n  overflow: hidden;\n  background-color: #fff;\n  vertical-align: top;\n  border-radius: 4px 0 0 4px;\n  box-shadow: ", ";\n  max-height: ", ";\n  transition: max-height 0.15s linear;\n  @media screen and (max-width: 1000px) {\n    width: 100% !important;\n    margin: 10px 0;\n    padding: 20px 20px\n      ", "\n      20px;\n    max-height: ", ";\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var Container$3 = styled.div(_templateObject$h(), function (_ref) {
  var containerInnerHeight = _ref.containerInnerHeight;
  return containerInnerHeight > 600 ? '80px' : '40px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.defaultShadow;
}, function (_ref3) {
  var show = _ref3.show,
      height = _ref3.height,
      containerInnerHeight = _ref3.containerInnerHeight;
  return !show && height ? "".concat(height - 80, "px") : "".concat(containerInnerHeight + 200, "px");
}, function (_ref4) {
  var containerInnerHeight = _ref4.containerInnerHeight;
  return containerInnerHeight > 600 ? '80px' : '20px';
}, function (_ref5) {
  var show = _ref5.show,
      containerInnerHeight = _ref5.containerInnerHeight;
  return !show ? '600px' : "".concat(containerInnerHeight + 200, "px");
});
var ContainerInner = styled.div(_templateObject2$9());
var ToggleButton = styled.div(_templateObject3$6(), function (_ref6) {
  var showToggle = _ref6.showToggle;
  return showToggle ? 'block' : 'none';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.headerFontFamily;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.primaryColor;
}, function (_ref10) {
  var containerInnerHeight = _ref10.containerInnerHeight;
  return containerInnerHeight > 600 ? 'block' : 'none';
});

var Proposition = function Proposition(_ref11) {
  var campaignContainerRef = _ref11.campaignContainerRef,
      formContainerRef = _ref11.formContainerRef,
      campaign = _ref11.campaign,
      children = _ref11.children,
      descriptionCollapse = _ref11.descriptionCollapse,
      descriptionExpand = _ref11.descriptionExpand;
  var containerInnerRef = React.useRef(null);

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  var _useState5 = React.useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      showToggle = _useState6[0],
      setShowToggle = _useState6[1];

  var containerInnerHeight = containerInnerRef && containerInnerRef.current && containerInnerRef.current.offsetHeight;

  var toggleShow = function toggleShow() {
    if (show) {
      campaignContainerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setShow(false);
    } else {
      setShow(true);
    }
  };

  var updateHeight = function updateHeight() {
    var offsetHeight = formContainerRef.current.offsetHeight;
    setHeight(offsetHeight);

    if (formContainerRef.current.offsetHeight > containerInnerRef.current.offsetHeight + 160) {
      setShowToggle(false);
    } else {
      setShowToggle(true);
    }
  };

  React.useEffect(function () {
    window.addEventListener('resize', updateHeight);
    return function () {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);
  React.useEffect(updateHeight, [campaign]);
  return React__default.createElement(Container$3, {
    height: height,
    show: show,
    containerInnerHeight: containerInnerHeight
  }, React__default.createElement(ContainerInner, {
    ref: containerInnerRef
  }, children), React__default.createElement(ToggleButton, {
    onClick: toggleShow,
    showToggle: showToggle,
    containerInnerHeight: containerInnerHeight
  }, show ? descriptionCollapse : descriptionExpand));
};

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px 40px;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 4px 4px 0 0;\n  @media screen and (max-width: 1000px) {\n    max-width: 100%;\n  }\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.2em;\n  @media screen and (max-width: 600px) {\n    font-size: 1em;\n  }\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 2rem;\n  text-transform: ", ";\n  @media screen and (max-width: 800px) {\n    font-size: 1.3rem;\n  }\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteral(["\n  padding: 40px;\n  display: block;\n  @media screen and (max-width: 1000px) {\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 20px;\n  }\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 460px;\n  min-height: 500px;\n  background-color: ", ";\n  color: ", ";\n  vertical-align: top;\n  border-radius: 4px;\n  box-shadow: ", ";\n  align-self: flex-start;\n  a {\n    color: ", ";\n    text-decoration: none;\n    background-image: linear-gradient(\n      120deg,\n      ", " 0%,\n      ", " 100%\n    );\n    padding-bottom: 2px;\n    background-repeat: no-repeat;\n    background-size: 100% 2px;\n    background-position: 0% 100%;\n    transition: background-size 0.1s linear;\n    &:hover,\n    &:focus {\n      background-size: 100% 4px;\n      background-image: linear-gradient(\n        120deg,\n        ", " 0%,\n        ", " 100%\n      );\n    }\n  }\n  @media screen and (max-width: 1000px) {\n    width: 100%;\n  }\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  max-width: 1160px;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  margin: 0 auto;\n  @media screen and (max-width: 1000px) {\n    flex-direction: column;\n    padding: 0 10px;\n  }\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  overflow: auto;\n  margin-bottom: ", ";\n  @media screen and (max-width: 800px) {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: auto;\n  position: relative;\n  background-color: ", ";\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var Container$4 = styled.div(_templateObject$i(), function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor || 'transparent';
});
var NodeFragment = "\n  fragment NodeFields on Node {\n    id\n    title\n    resourceType\n    slug\n    locale {\n      id\n      name\n      primary\n    }\n    image {\n      id\n      name\n      caption\n      alt\n      key\n      url\n    }\n    meta {\n      key\n      value\n    }\n    data {\n      key\n      data\n    }\n    status\n    nodeType\n  }";
var CampaignFragment = "\n  fragment CampaignFields on Campaign {\n    intro\n    description\n  }\n";
var MainContainerOuter = styled(Container$4)(_templateObject2$a(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediumSpacing;
});
var MainContainerInner = styled(Container$4)(_templateObject3$7());
var FormContainer = styled.div(_templateObject4$6(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.campaignFormBackgroundColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.campaignFormTextColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.defaultShadow;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.campaignFormLinkTextColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.campaignFormLinkLineColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.campaignFormLinkLineColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.campaignFormLinkLineColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.campaignFormLinkLineColor;
});
var FormContainerInner = styled.div(_templateObject5$6());
var Title$4 = styled.h1(_templateObject6$3(), function (_ref12) {
  var theme = _ref12.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});
var Intro$2 = styled.p(_templateObject7$3());
var CounterContainer = styled(FormContainerInner)(_templateObject8$2(), function (_ref13) {
  var theme = _ref13.theme;
  return theme.counterBackgroundColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.counterTextColor;
});
var DEFAULT_COPY$1 = {
  descriptionCollapse: 'Collapse proposition button text',
  descriptionExpand: 'Expand proposition button text',
  eventInfoTitle: 'Title for Event metadata',
  eventStartLabel: 'Label for Event Start date',
  eventEndLabel: 'Label for Event End date',
  eventLocationLabel: 'Label for Event Location',
  eventFeeLabel: 'Label for Event Fee',
  counterMessage: 'other people signed this petition'
};

var Campaign = function Campaign(_ref15) {
  var id = _ref15.id,
      resourceType = _ref15.resourceType,
      _ref15$node = _ref15.node,
      _node = _ref15$node === void 0 ? {} : _ref15$node,
      _ref15$formProps = _ref15.formProps,
      formProps = _ref15$formProps === void 0 ? {} : _ref15$formProps,
      _ref15$wrapElement = _ref15.wrapElement,
      wrapElement = _ref15$wrapElement === void 0 ? function (e) {
    return e;
  } : _ref15$wrapElement,
      _ref15$redirectUrlFor = _ref15.redirectUrlForNode,
      redirectUrlForNode = _ref15$redirectUrlFor === void 0 ? function () {
    return null;
  } : _ref15$redirectUrlFor,
      _ref15$copy = _ref15.copy,
      copy = _ref15$copy === void 0 ? {} : _ref15$copy,
      props = _objectWithoutProperties(_ref15, ["id", "resourceType", "node", "formProps", "wrapElement", "redirectUrlForNode", "copy"]);

  var campaignContainerRef = React.useRef(null);
  var formContainerRef = React.useRef(null);

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      signatureCount = _useState2[0],
      setSignatureCount = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      signatureGoal = _useState4[0],
      setSignatureGoal = _useState4[1];

  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      fundraiserRaised = _useState6[0],
      setFundraiserRaised = _useState6[1];

  var _useState7 = React.useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      fundraiserTarget = _useState8[0],
      setFundraiserTarget = _useState8[1];

  var _useState9 = React.useState(_node),
      _useState10 = _slicedToArray(_useState9, 2),
      node = _useState10[0],
      setNode = _useState10[1];

  var handleCampaignLoad = function handleCampaignLoad(campaign) {
    setNode(campaign);
    if (formProps.onLoad) formProps.onLoad(campaign);

    if (resourceType === 'node.petition') {
      setSignatureCount(campaign.signatureCount);
      setSignatureGoal(campaign.signatureGoal);
    }

    if (resourceType === 'node.fundraiser') {
      setFundraiserRaised(campaign.raised);
      setFundraiserTarget(campaign.target);
    }
  };

  var _DEFAULT_COPY$copy = _objectSpread$3({}, DEFAULT_COPY$1, {}, copy),
      descriptionCollapse = _DEFAULT_COPY$copy.descriptionCollapse,
      descriptionExpand = _DEFAULT_COPY$copy.descriptionExpand,
      eventInfoTitle = _DEFAULT_COPY$copy.eventInfoTitle,
      eventStartLabel = _DEFAULT_COPY$copy.eventStartLabel,
      eventEndLabel = _DEFAULT_COPY$copy.eventEndLabel,
      eventLocationLabel = _DEFAULT_COPY$copy.eventLocationLabel,
      eventFeeLabel = _DEFAULT_COPY$copy.eventFeeLabel,
      eventStartTime = _DEFAULT_COPY$copy.eventStartTime,
      eventEndTime = _DEFAULT_COPY$copy.eventEndTime,
      eventFee = _DEFAULT_COPY$copy.eventFee,
      petitionCounterMessage = _DEFAULT_COPY$copy.petitionCounterMessage,
      petitionCounterGoalText = _DEFAULT_COPY$copy.petitionCounterGoalText,
      fundraiserTargetText = _DEFAULT_COPY$copy.fundraiserTargetText,
      fundraiserCounterMessage = _DEFAULT_COPY$copy.fundraiserCounterMessage;

  var intro = node.intro,
      title = node.title;
  var element = React__default.createElement(React__default.Fragment, null, React__default.createElement(MainContainerOuter, _extends({}, props, {
    ref: campaignContainerRef
  }), React__default.createElement(MainContainerInner, null, React__default.createElement(Proposition, _extends({
    descriptionCollapse: descriptionCollapse,
    descriptionExpand: descriptionExpand
  }, {
    formContainerRef: formContainerRef,
    campaignContainerRef: campaignContainerRef,
    campaign: node
  }), title ? React__default.createElement(Title$4, null, title) : null, intro ? React__default.createElement(Intro$2, {
    fullWidth: true
  }, intro) : null, React__default.createElement(MobiledocRenderer$1, {
    content: node.description,
    mini: true
  })), React__default.createElement(FormContainer, {
    ref: formContainerRef
  }, typeof signatureCount === 'number' && node.resourceType === 'node.petition' && React__default.createElement(CounterContainer, null, React__default.createElement(PetitionCounter, {
    current: signatureCount,
    goal: signatureGoal,
    descriptionText: petitionCounterMessage,
    goalText: petitionCounterGoalText
  })), fundraiserRaised && typeof fundraiserRaised.amount === 'number' && node.resourceType === 'node.fundraiser' && React__default.createElement(CounterContainer, null, React__default.createElement(PetitionCounter, {
    current: fundraiserRaised.amount / 100,
    goal: fundraiserTarget.amount / 100,
    descriptionText: fundraiserCounterMessage,
    goalText: fundraiserTargetText,
    symbol: fundraiserRaised.currency.symbol
  })), React__default.createElement(FormContainerInner, null, React__default.createElement(CampaignForm$1, _extends({
    type: resourceType.split('.')[1],
    id: id,
    node: node,
    redirectUrl: redirectUrlForNode(node)
  }, formProps, {
    onLoad: handleCampaignLoad,
    nodeFragment: NodeFragment,
    campaignFragment: CampaignFragment
  })))))), resourceType === 'node.event' && (node.schedule || node.fee || node.location) && React__default.createElement(EventDetails, _extends({
    title: React__default.createElement(Title$4, null, eventInfoTitle),
    location: node.location
  }, {
    eventStartLabel: eventStartLabel,
    eventEndLabel: eventEndLabel,
    eventLocationLabel: eventLocationLabel,
    eventFeeLabel: eventFeeLabel,
    eventStartTime: eventStartTime,
    eventEndTime: eventEndTime,
    eventFee: eventFee
  })));
  return wrapElement(element, node);
};

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n          background-image: url(", ");\n          background-size: 100% auto;\n          background-repeat: no-repeat;\n          min-height: 500px;\n          max-height: 700px;\n          margin-top: ", ";\n          margin-bottom: ", ";\n          padding-top: 80px;\n          @media screen and (max-width: 1000px) {\n            margin-top: ", ";\n            min-height: 0;\n            margin-bottom: 0;\n            max-height: 0;\n            height: auto;\n            padding-top: 50%;\n          }\n        "]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  ", "\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: ", ";\n  @media screen and (max-width: 800px) {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper$1 = styled.div(_templateObject$j(), crane.wide);
var Container$5 = styled.div(_templateObject2$b(), function (_ref) {
  var theme = _ref.theme;
  return theme.largeSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediumSpacing;
});
var Image$2 = styled.div(_templateObject3$8(), function (_ref3) {
  var imageUrl = _ref3.imageUrl;
  return imageUrl ? css(_templateObject4$7(), imageUrl, function (_ref4) {
    var theme = _ref4.theme;
    return theme.largeSpacing;
  }, function (_ref5) {
    var imageMargin = _ref5.imageMargin;
    return "-".concat(imageMargin, "px") || 0;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.mediumSpacing;
  }) : null;
});

var CampaignCardView = function CampaignCardView(_ref7) {
  var id = _ref7.id,
      resourceType = _ref7.resourceType,
      props = _objectWithoutProperties(_ref7, ["id", "resourceType"]);

  var imageRef = React.useRef(null);

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      imageMargin = _useState2[0],
      setImageMargin = _useState2[1];

  React.useEffect(function () {
    var offsetHeight = imageRef.current.offsetHeight;
    setImageMargin(offsetHeight / 5);
  });

  if (!id || !resourceType) {
    console.warn('[hummingbird] CampaignCard does not reference an existing campaign');
    return null;
  }

  return React__default.createElement(Campaign, _extends({
    id: id,
    resourceType: resourceType
  }, props, {
    style: {
      marginTop: '0'
    },
    wrapElement: function wrapElement(element, campaign) {
      return React__default.createElement(Wrapper$1, null, React__default.createElement(Image$2, {
        ref: imageRef,
        imageUrl: campaign && campaign.image && campaign.image.url,
        imageMargin: imageMargin
      }), React__default.createElement(Container$5, null, element));
    }
  }));
};

var _CampaignCard = createCard({
  name: 'CampaignCard',
  renderWith: CampaignCardView
});

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useQueryString = function useQueryString() {
  var query = qs.parse(typeof window === 'undefined' ? '' : document.location.search.replace('?', ''));

  var updateQuery = function updateQuery(q) {
    // eslint-disable-next-line no-restricted-globals
    history.replaceState(history.state, null, ['?', qs.stringify(q)].join(''));
  };

  return {
    query: query,
    updateQuery: updateQuery,
    setQuery: function setQuery(q) {
      updateQuery(_objectSpread$4({}, query, {}, q));
    }
  };
};

function _templateObject5$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  background-color: rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 0 20px 15px #fff;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  @media screen and (max-width: 800px) {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  position: relative;\n  width: 100%;\n  max-width: 1180px;\n  height: auto;\n  padding: 0 20px;\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var Wide$1 = styled.div(_templateObject$k(), crane.wide);
var Container$6 = styled.div(_templateObject2$c(), function (_ref) {
  var theme = _ref.theme;
  return theme.largeSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediumSpacing;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediumSpacing;
});
var Overlay = styled.div(_templateObject3$9());
var Loading = styled(crane.Loading)(_templateObject4$8());
var PaginationControls = styled(crane.PaginationControls)(_templateObject5$7());
var QUERY = "\n  query NodesCardCustom($selector: NodeSelectorInput, $first: Int, $after: String) {\n    nodes(selector: $selector, first: $first, after: $after) {\n      edges {\n        node {\n          id\n          featured {\n            title\n            description\n            image {\n              alt\n              url\n            }\n          }\n          slug\n          ...NodeFields\n        }\n      }\n      pageInfo {\n        hasPreviousPage\n        hasNextPage\n        startCursor\n        endCursor\n        currentPage\n        totalPages\n      }\n    }\n  }\n";
var NODE_FRAGMENT = "\n  fragment NodeFields on Node {\n    id\n  }\n";

var scrollToTop = function scrollToTop(el) {
  var yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  var yOffset = -80;
  window.scrollTo({
    top: yCoordinate + yOffset,
    behavior: 'smooth'
  });
};

var getNodeQueryParams = function getNodeQueryParams(_ref5) {
  var items = _ref5.items,
      selector = _ref5.selector,
      type = _ref5.type,
      first = _ref5.first,
      after = _ref5.after;

  switch (type) {
    case 'selection':
      return {
        selector: {
          id: {
            "in": items
          }
        },
        first: 0,
        after: ''
      };

    default:
    case 'archive':
      return {
        selector: selector,
        first: first,
        after: after
      };
  }
};

var ItemDefault = function ItemDefault(_ref6) {
  var node = _ref6.node,
      props = _objectWithoutProperties(_ref6, ["node"]);

  return React__default.createElement(crane.ComplexCard, _extends({}, props, {
    item: node,
    title: node.featured && node.featured.title,
    image: node.featured && node.featured.image && node.featured.image.url,
    summary: node.featured && node.featured.description,
    size: "medium",
    bottomBackground: true,
    shadow: true
  }));
};

var NodesCardView = function NodesCardView(_ref7) {
  var text = _ref7.text,
      props = _objectWithoutProperties(_ref7, ["text"]);

  var itemComponent = props.itemComponent,
      _props$wrapItemElemen = props.wrapItemElement,
      wrapItemElement = _props$wrapItemElemen === void 0 ? function (e) {
    return e;
  } : _props$wrapItemElemen,
      _props$onNodeClick = props.onNodeClick,
      onNodeClick = _props$onNodeClick === void 0 ? function () {} : _props$onNodeClick,
      _props$nodeFragment = props.nodeFragment,
      nodeFragment = _props$nodeFragment === void 0 ? NODE_FRAGMENT : _props$nodeFragment,
      type = props.type,
      _props$selector = props.selector,
      selector = _props$selector === void 0 ? {} : _props$selector,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      sectionKey = props.sectionKey;

  var _useQueryString = useQueryString(),
      _useQueryString$query = _useQueryString.query,
      query = _useQueryString$query === void 0 ? {} : _useQueryString$query,
      setQuery = _useQueryString.setQuery;

  var Item = itemComponent || ItemDefault;
  var wings = useWings();
  var nodesCardContainerRef = React.useRef(null);

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasLoaded = _useState4[0],
      setHasLoaded = _useState4[1];

  var _useState5 = React.useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      nodes = _useState6[0],
      setNodes = _useState6[1];

  var _useState7 = React.useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      pageInfo = _useState8[0],
      setPageInfo = _useState8[1];

  var _useState9 = React.useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      containerHeight = _useState10[0],
      setContainerHeight = _useState10[1];

  var pageNumber = query["nc".concat(sectionKey, "page")] || '1';

  var fetchNodes = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref9,
          _ref9$first,
          first,
          _ref9$after,
          after,
          res,
          itemIds,
          _nodes,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref9 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref9$first = _ref9.first, first = _ref9$first === void 0 ? 12 : _ref9$first, _ref9$after = _ref9.after, after = _ref9$after === void 0 ? '0' : _ref9$after;
              setContainerHeight(nodesCardContainerRef.current.offsetHeight);
              setLoading(true);
              _context.next = 5;
              return wings.query([QUERY, nodeFragment].join('\n'), getNodeQueryParams({
                type: type,
                items: items.map(function (item) {
                  return item.nodeId;
                }),
                selector: selector,
                first: first,
                after: after
              }))["catch"](function (err) {
                return console.error(err);
              });

            case 5:
              res = _context.sent;
              itemIds = items.map(function (item) {
                return item.nodeId;
              });
              _nodes = res.nodes.edges.map(function (node) {
                return node.node;
              });
              setNodes(type === 'archive' ? _nodes : _nodes.sort(function (a, b) {
                return itemIds.indexOf(a.id) - itemIds.indexOf(b.id);
              }));
              setPageInfo(res.nodes.pageInfo);
              setHasLoaded(true);
              setLoading(false);
              setContainerHeight(0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchNodes() {
      return _ref8.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    fetchNodes({
      after: "".concat(Number(pageNumber) - 1)
    });
  }, []);
  return React__default.createElement(Wide$1, null, React__default.createElement(Container$6, {
    ref: nodesCardContainerRef,
    style: {
      minHeight: containerHeight
    }
  }, !hasLoaded ? React__default.createElement(Loading, {
    intent: "primary"
  }) : React__default.createElement(crane.FlexGrid, {
    divisions: 3,
    margins: 10,
    alignItems: "stretch",
    style: {
      marginLeft: '-10px',
      marginTop: '10px',
      marginBottom: '10px',
      width: 'calc(100% + 20px)'
    }
  }, nodes.map(function (node) {
    var itemElement = React__default.createElement(Item, {
      node: node,
      onClick: function onClick(e) {
        onNodeClick(node, {
          event: e
        });
      }
    });
    return React__default.createElement(React__default.Fragment, {
      key: "".concat(node.id)
    }, wrapItemElement(itemElement, {
      node: node
    }));
  })), hasLoaded && loading ? React__default.createElement(Overlay, {
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, React__default.createElement(Loading, {
    intent: "primary"
  })) : null, type === 'archive' && hasLoaded ? React__default.createElement(PaginationControls, {
    hasNextPage: pageInfo.hasNextPage,
    hasPreviousPage: pageInfo.hasPreviousPage,
    totalPages: pageInfo.totalPages,
    currentPage: pageInfo.currentPage || 1,
    onPageChange: function onPageChange(page) {
      setQuery(_defineProperty({}, "nc".concat(sectionKey, "page"), page));
      fetchNodes({
        after: "".concat(page > 1 ? page - 1 : 0)
      });
      scrollToTop(nodesCardContainerRef.current);
    }
  }) : null));
};

var _NodesCard = createCard({
  name: 'NodesCard',
  renderWith: NodesCardView
});

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var _HeaderCard = _objectSpread$5({}, _ChapterCard, {
  name: 'HeaderCard'
});

var ImageCard$1 = _ImageCard;
var InsightCard = _InsightCard;
var QuoteCard = _QuoteCard;
var TestimonialCard$1 = _TestimonialCard;
var EmbedCard$1 = _EmbedCard;
var HeaderCard = _HeaderCard;
var CTACard = _CTACard;
var DataCard = _DataCard;
var CollectionCard = _CollectionCard;
var QACard = _QACard;
var TextCard = _TextCard;
var CampaignCard = _CampaignCard;
var NodesCard = _NodesCard;
var CampaignCardView$1 = CampaignCardView;
var cards = {
  ImageCard: _ImageCard,
  InsightCard: _InsightCard,
  QuoteCard: _QuoteCard,
  TestimonialCard: _TestimonialCard,
  EmbedCard: _EmbedCard,
  ChapterCard: _ChapterCard,
  HeaderCard: _HeaderCard,
  CTACard: _CTACard,
  DataCard: _DataCard,
  CollectionCard: _CollectionCard,
  QACard: _QACard,
  TextCard: _TextCard,
  CampaignCard: _CampaignCard,
  NodesCard: _NodesCard
};
var allCards = Object.values(cards);

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var mergeCards = function mergeCards(base, overrides) {
  var names = overrides.map(function (_ref) {
    var name = _ref.name;
    return name;
  });
  var filtered = base.filter(function (c) {
    return !includes(names, c.name);
  });
  return filtered.concat(overrides);
};

var convertCard = function convertCard(_ref2) {
  var View = _ref2.View,
      card = _objectWithoutProperties(_ref2, ["View"]);

  return _objectSpread$6({}, card, {
    render: function render(_ref3) {
      var payload = _ref3.payload,
          props = _objectWithoutProperties(_ref3, ["payload"]);

      return React__default.createElement(View, _extends({}, payload, props));
    }
  });
};

var Content = /*#__PURE__*/function (_Component) {
  _inherits(Content, _Component);

  function Content() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Content);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Content)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onLoad", function () {
      var _this$props = _this.props,
          content = _this$props.content,
          onLoad = _this$props.onLoad;
      if (!onLoad) return;
      var doc = JSON.parse(content);
      onLoad({
        chapters: doc.cards.filter(function (c) {
          return ['HeaderCard', 'ChapterCard'].indexOf(c[0]) > -1;
        }).map(function (c) {
          return c[1];
        }).map(function (chapter) {
          return _objectSpread$6({
            id: slugify(chapter.title)
          }, chapter);
        })
      });
    });

    return _this;
  }

  _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var content = this.props.content;
      if (!content) return;
      this.onLoad();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          cards = _this$props2.cards,
          onLoad = _this$props2.onLoad,
          props = _objectWithoutProperties(_this$props2, ["cards", "onLoad"]);

      return React__default.createElement(MobiledocRenderer$1, _extends({}, props, {
        cards: mergeCards(allCards, cards).map(convertCard)
      }));
    }
  }]);

  return Content;
}(React.Component);

_defineProperty(Content, "propTypes", {
  cards: PropTypes.array,
  onLoad: PropTypes.func
});

_defineProperty(Content, "defaultProps", {
  cards: [],
  onLoad: null
});

var getNodeMetaTags = function getNodeMetaTags(node) {
  var _node$platforms = node.platforms,
      all = _node$platforms.all,
      facebook = _node$platforms.facebook,
      twitter = _node$platforms.twitter;
  return {
    title: all.title,
    meta: [{
      name: 'description',
      content: all.description
    }, {
      property: 'og:title',
      content: facebook.title
    }, {
      property: 'og:description',
      content: facebook.description
    }, {
      property: 'og:image',
      content: facebook.imageUrl
    }, {
      property: 'og:image:secure_url',
      content: facebook.imageUrl
    }, {
      property: 'og:type',
      content: 'article'
    }, {
      name: 'twitter:title',
      content: twitter.title
    }, {
      name: 'twitter:description',
      content: twitter.description
    }, {
      name: 'twitter:image',
      content: twitter.imageUrl
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    }]
  };
};

exports.CTACard = CTACard;
exports.Campaign = Campaign;
exports.CampaignCard = CampaignCard;
exports.CampaignCardView = CampaignCardView$1;
exports.CollectionCard = CollectionCard;
exports.Content = Content;
exports.DataCard = DataCard;
exports.EmbedCard = EmbedCard$1;
exports.HeaderCard = HeaderCard;
exports.ImageCard = ImageCard$1;
exports.InsightCard = InsightCard;
exports.NodesCard = NodesCard;
exports.QACard = QACard;
exports.QuoteCard = QuoteCard;
exports.TestimonialCard = TestimonialCard$1;
exports.TextCard = TextCard;
exports.WingsProvider = Wings;
exports.allCards = allCards;
exports.createCard = createCard;
exports.getNodeMetaTags = getNodeMetaTags;
exports.slugify = slugify;
exports.useWings = useWings;
exports.withWings = withWings;